module.exports = __webpack_public_path__ + "img/community_challenges.3a77650d.svg";